import React from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import GradeIcon from "assets/imgs/Home/icons/grade.svg";
import LogoutWhiteIcon from "assets/imgs/Home/icons/logoutWhite.svg";
import MailIconWhite from "assets/imgs/Home/icons/mailIconWhite.svg";
import MessageIconWhite from "assets/imgs/Home/icons/messageIconWhite.svg";
import AddChildIcon from "assets/imgs/icons/add_child.svg";
import ArrowDropDown from "assets/imgs/icons/arrowDropDown.svg";
import ArrowDownIcon from "assets/imgs/icons/arrow_linear.svg";
import CalenderIcon from "assets/imgs/icons/calender.svg";
import ChangeTutorFilled from "assets/imgs/icons/change_tutor_filled.svg";
import CoursesIcon from "assets/imgs/icons/courses.svg";

//import Logo from "assets/imgs/icons/cif-logo-white.svg";
import NotificationIcon from "assets/imgs/icons/notification.svg";
import ReferalStatusIcon from "assets/imgs/icons/referel_status.svg";
import SettingsIcon from "assets/imgs/icons/settings.svg";
import StudentRecord from "assets/imgs/icons/student_record.svg";
import AvatarLarge from "assets/imgs/icons/user_avatar_lg.svg";
import NotificationDropdown from "components/NotificationDropdown/NotificationDropdown";
import ProfileDropdown from "components/ProfileDropdown/ProfileDropdown";
import GlobalSearch from "components/GlobalSearch/GlobalSearch";
import { useCallback, useContext, useState } from "react";
import {
  Container,
  Nav,
  Navbar,
  NavDropdown,
  Offcanvas,
} from "react-bootstrap";
import { AuthContext } from "context/AuthContext";
import { useMutation, useQueries, useQuery } from "@tanstack/react-query";
import getProfile from "service/user/shared/get-profile";
import "./header.scss";
import { ROUTES } from "routes";
import { Link, useNavigate } from "react-router-dom";
import debounce from "lodash.debounce";
import axios from "axios";
import searchCourses from "service/courses/search-course";
import getCourseList from "service/courses/course-list";
import { TreePicker } from "rsuite";
import HomeHeader from "assets/imgs/icons/home_header.svg";
import ChatHeader from "assets/imgs/icons/chat_header.svg";
import SubjectHeader from "assets/imgs/icons/subject_header.svg";
import Microphone from "assets/imgs/parent/microphone.svg";
import SettingsHeader from "assets/imgs/icons/settings_header.svg";
import ChatNotification from "components/ChatNotification/ChatNotification";
import getTutors from "service/user/parent/chat/get-tutors";
import getCsm from "service/user/parent/chat/get-csm";
import { db } from "../../firebase";
import { getDoc, doc } from "firebase/firestore";
import { collection, query, where, onSnapshot } from "firebase/firestore";
import { ChatContext } from "context/ChatContext";

const renderTooltip = (props) => <Tooltip id="header-tooltip">{props}</Tooltip>;

const CoursesToggle = React.forwardRef(({ children, onClick }, ref) => (
  <OverlayTrigger placement="top" overlay={renderTooltip("Courses")}>
    <div ref={ref} onClick={onClick} className="header__filter-btn">
      <img src={SubjectHeader} alt="" className="mx-2 cif__header-icon" />
    </div>
  </OverlayTrigger>
));

function Header() {
  const { authState, logout, isParent, isTutor, isCoordinator, isStudent } =
    useContext(AuthContext);
  const navigate = useNavigate();
  let profile = ROUTES.STUDENT_PROFILE;
  let home = ROUTES.HOME;
  if (isParent()) {
    profile = ROUTES.PARENT_PROFILE;
  } else if (isTutor()) {
    profile = ROUTES.TUTOR_PROFILE;
    home = ROUTES.TUTOR_DASHBOARD;
  } else if (isCoordinator()) {
    profile = ROUTES.CSM_VIEW_PROFILE;
    home = ROUTES.CSM_DASHBOARD;
  } else if (isStudent()) {
    profile = ROUTES.STUDENT_PERSONAL_PROFILE;
    home = ROUTES.STUDENT_DASHBOARD;
  }

  const [data, setData] = useState({});
  const queries = useQueries({
    queries: [
      {
        queryKey: ["profile"],
        queryFn: () => getProfile(authState.userInfo.cifNumber),
        enabled: !!authState?.userInfo?.cifNumber,
        onSuccess: (d = []) => {
          setData(d);
        },
      },
      {
        queryKey: ["csm-list"],
        queryFn: () => getCsm(authState?.userInfo?.cifNumber),
        enabled: !!authState?.userInfo?.cifNumber,
        onSuccess: (d) => {
          if (d && d.length > 0) {
            let list = [];

            list = d.filter((item) => {
              if (item.firebaseId) {
                return item.firebaseId;
              }
            });
            _loadUsers(list, "csm");
          }
        },
      },
      {
        queryKey: ["tutors-list"],
        queryFn: () => getTutors(authState?.userInfo?.cifNumber),
        enabled: !!authState?.userInfo?.cifNumber,
        onSuccess: (d) => {
          if (d && d.length > 0) {
            let list = [];
            list = d.filter((item) => {
              if (item.firebaseId) {
                return item.firebaseId;
              }
            });
            _loadUsers(list, "tutor");
          }
        },
      },
    ],
  });

  const [coursesMenuOpen, setCoursesMenuOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);

  const userFbId = authState?.userInfo?.firebaseUid;
  const [newMessage, setNewMessage] = useState(false);

  const _loadUsers = async (list, type) => {
    list = list.map((l) => l.firebaseId);
    let users = [];
    if (list.length > 10) {
      let newList = [];
      for (let i = 0; i < list.length / 10; i++) {
        newList.push(
          list.filter((l, ind) => {
            if (ind >= i * 10 && ind < (i + 1) * 10) {
              return l;
            }
          })
        );
        const usersRef = collection(db, "users");
        const q = query(usersRef, where("uid", "in", newList[i]));
        const unsub = onSnapshot(q, (querySnapshot) => {
          querySnapshot.forEach((doc) => {
            users.push(doc.data());
          });
          let newUsers = [];
          users.map((user) => {
            let userId = user.uid;
            const id =
              userFbId > userId
                ? `${userFbId + userId}`
                : `${userId + userFbId}`;
            onSnapshot(doc(db, "lastMsg", id), (doc) => {
              let data = doc.data();
              newUsers = newUsers.filter(function (obj) {
                return obj?.uid !== data?.from && obj?.uid !== data?.to;
              });
              newUsers.push(data);
              if (data?.unread && data?.to === userFbId && !newMessage) {
                setNewMessage(true);
              }
            });
            // return () => unsub2();
          });
        });
        // return () => unsub();
      }
    } else {
      const usersRef = collection(db, "users");
      const q = query(usersRef, where("uid", "in", list));
      const unsub = onSnapshot(q, (querySnapshot) => {
        querySnapshot.forEach((doc) => {
          users.push(doc.data());
        });
        let newUsers = [];
        users.map((user) => {
          let userId = user.uid;
          const id =
            userFbId > userId ? `${userFbId + userId}` : `${userId + userFbId}`;
          onSnapshot(doc(db, "lastMsg", id), (doc) => {
            let data = doc.data();
            newUsers = newUsers.filter(function (obj) {
              return obj?.uid !== data?.from && obj?.uid !== data?.to;
            });
            newUsers.push(data);
            if (data?.unread && data?.to === userFbId && !newMessage) {
              setNewMessage(true);
            }
          });
        });
      });
      return () => unsub();
    }
  };

  const renderButton = (props, ref) => {
    return (
      <span className="d-flex align-items-center" {...props} ref={ref}>
        <span className="me-2">Courses</span>
        <img src={ArrowDropDown} alt="" />
      </span>
    );
  };

  const renderTooltip = (props) => (
    <Tooltip id="header-tooltip">{props}</Tooltip>
  );

  const [cancelToken, setCancelToken] = useState();
  const debouncedSearch = useCallback(
    debounce(async (value) => {
      if (typeof cancelToken !== "undefined") {
        cancelToken.cancel();
      }

      if (value === "") return;

      setCancelToken(axios.CancelToken.source());
      try {
        const courses = await searchCourses(value, cancelToken);
        const res = [];

        for (let i = 0; i < courses?.length; i++) {
          res.push({ label: courses[i].groupName, value: courses[i].groupId });
        }

        setSearchResults(res);
      } catch (error) {
        console.log(error);
      } finally {
        setCancelToken(undefined);
      }
    }, 250),
    []
  );
  const courseList = useQuery(["course-list"], getCourseList, {
    enabled: !isStudent(),
  });

  const courseTreedata = [
    {
      value: "Beginner",
      label: "Beginner",
      children: courseList.data?.Beginner?.map(({ courseName, courseId }) => {
        return {
          value: courseId,
          label: courseName,
        };
      }),
    },
    {
      value: "Intermediate",
      label: "Intermediate",
      children: courseList.data?.Intermediate?.map(
        ({ courseName, courseId }) => {
          return {
            value: courseId,
            label: courseName,
          };
        }
      ),
    },
    {
      value: "Advanced",
      label: "Advanced",
      children: courseList.data?.Advanced?.map(({ courseName, courseId }) => {
        return {
          value: courseId,
          label: courseName,
        };
      }),
    },
  ];

  return (
    <Navbar className="cif__header" expand={true}>
      <ChatNotification />
      <Container
        fluid
        className={
          isStudent() ? "justify-content-between" : "cif__nav-container"
        }
      >
        {/* <Navbar.Toggle
            aria-controls="offcanvasNavbar"
            bsPrefix="cif__toggler cif__sm-nav"
          >
            <img src={MenuIcon} alt="" />
          </Navbar.Toggle> */}
        {/* <Navbar.Brand href={home}>
          <img src={Logo} alt="" className="cifLogo" />
        </Navbar.Brand> */}
        <div className="d-flex gap-3">
          <Navbar.Brand href={home}>
            <OverlayTrigger placement="top" overlay={renderTooltip("Home")}>
              <img
                src={HomeHeader}
                alt=""
                className="cifHeaderIcon cif__header-icon"
              />
            </OverlayTrigger>
          </Navbar.Brand>
          <div className="cif__nav-item cif__nav-form-container d-none d-lg-flex gap-1 cifHeader__filter_wrapper">
            <GlobalSearch />

            {/* <TreePicker
            defaultExpandAll
            data={datas}
            toggleAs={CustomFilterToggle}
            placeholder="Filter"
            caretAs={null}
          /> */}
          </div>
        </div>

        <div className="d-flex header__nav-link-group align-items-center cifHeader__courses_wrapper">
          {/* <NavDropdown
        {!isStudent() && (
          <>
            <div className="cif__nav-item cif__nav-form-container d-none d-lg-flex gap-1 cifHeader__filter_wrapper">
              <SearchInput
                variant="primary_white"
                className="w-100"
                placeholder="Find Your Course"
                value={searchTerm}
                data={searchResults}
                onChange={(v) => {
                  if (typeof v === "number") return;
                  setSearchTerm(v);
                  debouncedSearch(v);
                }}
                onSelect={(v, { label }) =>
                  navigate(ROUTES.SEARCH_RESULTS, {
                    state: { id: v, course: label },
                  })
                }
              />
              <FilterDropdown
                toggler={CustomFilterToggle}
                togglerText="Filter"
              />
            </div>
            <div className="d-flex header__nav-link-group align-items-center cifHeader__courses_wrapper">
              {/* <NavDropdown
            title="Courses"
            id="basic-nav-dropdown"
            className="cif__nav-dropdown"
          >
            <div className="cursor-pointer">item 1</div>
            <div className="cursor-pointer">item 2</div>
            <div className="cursor-pointer">item 3</div>
          </NavDropdown> */}

          {/* <RDropdown loading={courseList.isLoading} renderToggle={renderButton}>
            <div className="cifHeader__courses_menu d-flex gap-5 cif__text_primary font-md">
              <div>
                <span className="fw-500">Beginner</span>
                <ul>
                  {courseList.data?.Beginner?.map(
                    ({ courseName, courseId }) => (
                      <li
                        onClick={() =>
                          navigate(ROUTES.ADD_SUBJECT, {
                            state: { courseId, course: courseName },
                          })
                        }
                        className="cursor-pointer"
                        key={courseId}
                      >
                        {courseName}
                      </li>
                    )
                  )}
                </ul>
              </div>
              <div>
                <span className="fw-500">Intermediate</span>
                <ul>
                  {courseList.data?.Intermediate?.map(
                    ({ courseName, courseId }) => (
                      <li
                        onClick={() =>
                          navigate(ROUTES.ADD_SUBJECT, {
                            state: { courseId, course: courseName },
                          })
                        }
                        className="cursor-pointer"
                        key={courseId}
                      >
                        {courseName}
                      </li>
                    )
                  )}
                </ul>
              </div>
              <div>
                <span className="fw-500">Advanced</span>
                <ul>
                  {courseList.data?.Advanced?.map(
                    ({ courseName, courseId }) => (
                      <li
                        onClick={() =>
                          navigate(ROUTES.ADD_SUBJECT, {
                            state: { courseId, course: courseName },
                          })
                        }
                        className="cursor-pointer"
                        key={courseId}
                      >
                        {courseName}
                      </li>
                    )
                  )}
                </ul>
              </div>
            </div>
          </RDropdown> */}

          {/* <NavDropdown
            title="Your Schedule"
            id="basic-nav-dropdown"
            className="cif__nav-dropdown cursor-pointer"
          >
            <div className="cursor-pointer">item 1</div>
            <div className="cursor-pointer">item 2</div>
            <div className="cursor-pointer">item 3</div>
          </NavDropdown> */}
        </div>

        <div className="d-flex gap-3">
          <div className="cif__nav-item d-flex gap-3 header__nav-link-group align-items-center">
            {!isStudent() ? (
              <>
                <OverlayTrigger placement="top" overlay={renderTooltip("Chat")}>
                  {/* <Link
                to={ROUTES.VIEW_SCHEDULE}
                className=" ms-2 text-decoration-none"
              > */}
                  <div className={`${newMessage ? "new-message" : ""}`}>
                    <img
                      className={`cursor-pointer cif__header-icon mx-2 `}
                      onClick={() => navigate(ROUTES.CHAT)}
                      src={ChatHeader}
                      alt=""
                    />
                  </div>
                  {/* </Link> */}
                </OverlayTrigger>
                <OverlayTrigger placement="top" overlay={renderTooltip("FAQ")}>
                  {/* <Link
                to={ROUTES.VIEW_SCHEDULE}
                className=" ms-2 text-decoration-none"
              > */}
                  <div>
                    <img
                      className={`cursor-pointer cif__header-icon mx-2 `}
                      onClick={() => navigate(ROUTES.FAQ)}
                      src={Microphone}
                      alt=""
                    />
                  </div>
                  {/* </Link> */}
                </OverlayTrigger>
                <TreePicker
                  menuClassName="header__course_menu_box"
                  block={false}
                  data={courseTreedata}
                  toggleAs={CoursesToggle}
                  placeholder="Filter"
                  caretAs={null}
                  onSelect={({ value, label }) => {
                    // console.log("Value : ", value);
                    // console.log("Label : ", label);
                    navigate(ROUTES.ADD_SUBJECT, {
                      state: { courseId: value, course: label },
                    });
                  }}
                />
              </>
            ) : null}

            {/* <OverlayTrigger
              placement="top"
              overlay={renderTooltip("Schedules")}
            >
              <Link
                to={ROUTES.VIEW_SCHEDULE}
                className=" ms-2 text-decoration-none"
              >
                <img
              className="cursor-pointer cif__header-icon"
              src={SettingsIcon}
              alt=""
            />
                Schedule
              </Link>
            </OverlayTrigger> */}

            <NotificationDropdown />

            {!isStudent() ? (
              <>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Settings")}
                >
                  <Link to={ROUTES.SETTINGS} className="cursor-pointer ">
                    <img
                      className="cursor-pointer cif__header-icon mx-2"
                      src={SettingsHeader}
                      alt=""
                    />
                  </Link>
                </OverlayTrigger>
              </>
            ) : null}
          </div>

          <div className="d-flex align-items-center profile-dropdown-container">
            {/* <Link
            to={ROUTES.HOME}
            id="basic-nav-dropdown"
            className="cif__nav-dropdown me-3 cursor-pointer"
          >
            <img className="cursor-pointer" src={HomeIcon} alt="" />
          </Link> */}
            <ProfileDropdown title={data?.fullName} />
            {/* <div
            id="basic-nav-dropdown"
            className="cif__nav-dropdown cifHeader__profile_wrapper"
          >
            <NavDropdown
              title={
                <>
                  <img className="cursor-pointer" src={AvatarIcon} alt="" />
                  <span className="ms-2 header__nav-link-group cursor-pointer">
                    Dev Patel
                  </span>
                </>
              }
              id="basic-nav-dropdown"
              className="cif__nav-dropdown cif__nav-user-hover cursor-pointer"
            >
              <div className="cursor-pointer d-flex align-items-center gap-2 my-1 cifHeader__profile_dropdown_item">
                <img src={ProfileIconPrimary} alt="" />
                <span>Profile</span>
              </div>
              <div className="cursor-pointer d-flex align-items-center gap-3 my-1 cifHeader__profile_dropdown_item">
                <img src={FaqIcon} alt="" />
                <span>FAQ</span>
              </div>
              <div className="cursor-pointer d-flex align-items-center gap-3 my-1 cifHeader__profile_dropdown_item">
                <img src={LogoutIcon} alt="" />
                <span>Logout</span>
              </div>
            </NavDropdown>
          </div> */}
          </div>
        </div>
        <Navbar.Offcanvas
          id="offcanvasNavbar"
          aria-labelledby="offcanvasNavbarLabel"
          placement="end"
          className="cif__offcanvas cif__sm-nav"
          closeVariant="white"
        >
          <Offcanvas.Header closeButton className="justify-content-end">
            {/* <img src={CloseBtnIcon} alt="" className="me-3" /> */}
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Nav className="justify-content-end flex-grow-1 pe-3">
              <div className="header__sm-nav-item d-flex align-items-center">
                <img src={AvatarLarge} alt="" />
                <span className="ms-5 font-lg fw-500"> {data?.fullName}</span>
              </div>

              {/* courses menu start */}
              <NavDropdown
                show={coursesMenuOpen}
                onClick={(e) => {
                  e.stopPropagation();
                  setCoursesMenuOpen(!coursesMenuOpen);
                }}
                title={
                  <div className="d-flex align-items-center gap-2 header__sm-dropdown-arrow-down">
                    <img src={CoursesIcon} alt="" />
                    <span className="ms-2">Courses</span>
                    <img
                      src={ArrowDownIcon}
                      alt=""
                      className="header__sm-arrow-icon"
                    />
                  </div>
                }
                id="offcanvasNavbarDropdown"
                className="text-white header__sm-nav-item"
              >
                <NavDropdown.Item
                  onClick={(e) => {
                    e.stopPropagation();
                    // console.log("clicked");
                  }}
                  href="#action4"
                >
                  {/* submenu start */}
                  <NavDropdown
                    title={
                      <div className="d-flex align-items-center gap-2 header__sm-dropdown-arrow-down">
                        <img src={GradeIcon} alt="" />
                        <span className="ms-2">Beginner</span>
                        <img
                          src={ArrowDownIcon}
                          alt=""
                          className="header__sm-arrow-icon"
                        />
                      </div>
                    }
                    id="offcanvasNavbarDropdown"
                    className="text-white header__sm-nav-item"
                  >
                    {courseList.data?.Beginner?.map(
                      ({ courseName, courseId }) => (
                        <NavDropdown.Item
                          key={courseId}
                          onClick={(e) => {
                            e.stopPropagation();
                            // console.log("clicked");
                          }}
                          href={"/" + courseName}
                        >
                          {courseName}
                        </NavDropdown.Item>
                      )
                    )}
                  </NavDropdown>
                  {/* submenu end */}
                  {/* submenu start */}
                  <NavDropdown
                    title={
                      <div className="d-flex align-items-center gap-2 header__sm-dropdown-arrow-down">
                        <img src={GradeIcon} alt="" />
                        <span className="ms-2">Intermediate</span>
                        <img
                          src={ArrowDownIcon}
                          alt=""
                          className="header__sm-arrow-icon"
                        />
                      </div>
                    }
                    id="offcanvasNavbarDropdown"
                    className="text-white header__sm-nav-item"
                  >
                    {courseList.data?.Intermediate?.map(
                      ({ courseName, courseId }) => (
                        <NavDropdown.Item
                          key={courseId}
                          onClick={(e) => {
                            e.stopPropagation();
                            // console.log("clicked");
                          }}
                          href={"/" + courseName}
                        >
                          {courseName}
                        </NavDropdown.Item>
                      )
                    )}
                  </NavDropdown>
                  {/* submenu end */}
                  {/* submenu start */}
                  <NavDropdown
                    title={
                      <div className="d-flex align-items-center gap-2 header__sm-dropdown-arrow-down">
                        <img src={GradeIcon} alt="" />
                        <span className="ms-2">Advanced</span>
                        <img
                          src={ArrowDownIcon}
                          alt=""
                          className="header__sm-arrow-icon"
                        />
                      </div>
                    }
                    id="offcanvasNavbarDropdown"
                    className="text-white header__sm-nav-item"
                  >
                    {courseList.data?.Advanced?.map(
                      ({ courseName, courseId }) => (
                        <NavDropdown.Item
                          key={courseId}
                          onClick={(e) => {
                            e.stopPropagation();
                            // console.log("clicked");
                          }}
                          href={"/" + courseName}
                        >
                          {courseName}
                        </NavDropdown.Item>
                      )
                    )}
                  </NavDropdown>
                  {/* submenu end */}
                </NavDropdown.Item>
              </NavDropdown>
              {/* courses menu end */}
              <NavDropdown
                title={
                  <div className="d-flex align-items-center gap-2 header__sm-dropdown-arrow-down">
                    <img src={CalenderIcon} alt="" />
                    <span className="ms-2">Your Schedule</span>
                    <img
                      src={ArrowDownIcon}
                      alt=""
                      className="header__sm-arrow-icon"
                    />
                  </div>
                }
                id="offcanvasNavbarDropdown"
                className="header__sm-nav-item"
              >
                <NavDropdown.Item href="#action4">Item</NavDropdown.Item>
                <NavDropdown.Item href="#action5">Item</NavDropdown.Item>
              </NavDropdown>
              <Link
                to={ROUTES.NOTIFICATIONS}
                className="header__sm-nav-item d-flex"
              >
                <img src={NotificationIcon} alt="" />
                <span className="ms-3">Notifications</span>
              </Link>
              <Link to={ROUTES.SETTINGS} className="header__sm-nav-item d-flex">
                <img src={SettingsIcon} alt="" />
                <span className="ms-3"> Settings</span>
              </Link>

              <Link
                to={ROUTES.STUDENT_RECORDS}
                className="header__sm-nav-item d-flex"
              >
                <img src={AddChildIcon} alt="" />
                <span className="ms-3"> Student Records</span>
              </Link>

              <Link
                to={ROUTES.PROGRESS_REPORT}
                className="header__sm-nav-item d-flex"
              >
                <img src={StudentRecord} alt="" />
                <span className="ms-3"> Progress Report</span>
              </Link>

              <Link
                to={ROUTES.REFERRAL_STATUS}
                className="header__sm-nav-item d-flex"
              >
                <img src={ChangeTutorFilled} alt="" />
                <span className="ms-3"> Referral Status</span>
              </Link>

              <div className="header__sm-nav-item fw-500">Connect</div>

              <Link to={ROUTES.MAIL_US} className="header__sm-nav-item d-flex">
                <img src={MailIconWhite} alt="" />
                <span className="ms-3 fw-300">Inbox</span>
              </Link>
              <Link to={ROUTES.CHAT} className="header__sm-nav-item d-flex">
                <img src={MessageIconWhite} alt="" />
                <span className="ms-3 fw-300">Messenger</span>
              </Link>

              <div className="header__sm-nav-item fw-500">Account</div>

              <Link to={profile} className="header__sm-nav-item d-flex">
                <img src={StudentRecord} alt="" />
                <span className="ms-3 fw-300">Edit Profile</span>
              </Link>
              <Link to={ROUTES.FAQ} className="header__sm-nav-item d-flex">
                <img src={ReferalStatusIcon} alt="" />
                <span className="ms-3 fw-300">Help</span>
              </Link>
              <div
                onClick={logout}
                className="header__sm-nav-item d-flex cursor-pointer"
              >
                <img src={LogoutWhiteIcon} alt="" />
                <span className="ms-3 fw-300">Logout</span>
              </div>
            </Nav>
          </Offcanvas.Body>
        </Navbar.Offcanvas>
      </Container>
    </Navbar>
  );
}

export default Header;
